export function findInViewHierarchy(registryName, blcktive, name) {
  const instance = findInstance(registryName, blcktive, name);
  return instance ? instance[registryName][name] : null;
}

export function findInstance(registryName, blcktive, name) {
  while (blcktive) {
    if (name in blcktive[registryName]) {
      return blcktive;
    }

    if (blcktive.isolated) {
      return null;
    }

    blcktive = blcktive.parent;
  }
}
